import React, { ReactNode } from 'react';
import { notification } from 'antd';
import {
  InfoCircleOutlined,
  WarningOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import styles from './COAlert.module.scss';
import {
  NotificationCases,
  NotificationProps,
  NotificationThemeColors,
} from 'enums/COAlertEnums';

export interface COAlertProps {
  children?: ReactNode;
  descriptionText: string;
  large?: boolean;
  type:
    | NotificationCases.INFO
    | NotificationCases.SUCCESS
    | NotificationCases.FAILED
    | NotificationCases.WARNING
    | NotificationCases.ERROR;
}

const COAlert: React.FC<COAlertProps> = ({
  descriptionText,
  large,
  type,
  children,
}: COAlertProps) => {
  const [api, contextHolder] = notification.useNotification();

  //handling AntD notification calls based on the 'type' passed by the user
  const openNotification = (descriptionText: string, type: string) => {
    switch (type) {
      case NotificationCases.INFO:
        api.open({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          icon: (
            <InfoCircleOutlined
              className={
                large
                  ? styles.notificationLargeIcon
                  : styles.notificationSmallIcon
              }
            />
          ),
          className: styles.notificationContainer,
          duration: 11,
        });
        break;
      case NotificationCases.SUCCESS:
        api.success({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          icon: (
            <CheckOutlined
              style={{ color: NotificationThemeColors.BLUE }}
              className={
                large
                  ? styles.notificationLargeIcon
                  : styles.notificationSmallIcon
              }
            />
          ),
          className: styles.notificationContainerSuccess,
          duration: 11,
        });
        break;
      case NotificationCases.WARNING:
        api.warning({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          icon: (
            <WarningOutlined
              style={{ color: NotificationThemeColors.ORANGE }}
              className={
                large
                  ? styles.notificationLargeIcon
                  : styles.notificationSmallIcon
              }
            />
          ),
          className: styles.notificationContainerOrangeWarning,
          duration: 11,
        });
        break;
      case NotificationCases.FAILED:
        api.error({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          icon: (
            <InfoCircleOutlined
              style={{ color: NotificationThemeColors.RED }}
              className={
                large
                  ? styles.notificationLargeIcon
                  : styles.notificationSmallIcon
              }
            />
          ),
          className: styles.notificationContainerWarning,
          duration: 11,
        });
        break;
      case NotificationCases.ERROR:
        api.error({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          className: styles.notificationContainerWarning,
          duration: 11,
        });
        break;
      default:
        api.open({
          message: NotificationProps.EMPTY_STRING,
          description: descriptionText,
          icon: (
            <InfoCircleOutlined
              className={
                large
                  ? styles.notificationLargeIcon
                  : styles.notificationSmallIcon
              }
            />
          ),
          className: styles.notificationContainer,
          duration: 11,
        });
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div
        className={styles.btnContainer}
        onClick={() => openNotification(descriptionText, type)}
        role={NotificationProps.BUTTON_ROLE}>
        {children}
      </div>
    </>
  );
};

export default COAlert;
